import React, { useState, useEffect } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import { Button } from 'govuk-react-jsx';
import { useSelector } from 'react-redux';
import { getChargePointDetails } from '../../firebase';
import {
  getCurrentLanguage,
  getCopyProviderCY,
  getCopyProviderEN,
} from '../../features/app/appSlice';
import { getApplicationDocumentId } from '../../features/application/applicationJourneySlice';
import useTitle from '../../hooks/useTitle';

const UnderAllocationOfSockets = () => {
  const history = useHistory();
  const currentLanguage = useSelector(getCurrentLanguage);
  const copyProviderCY = useSelector(getCopyProviderCY);
  const copyProviderEN = useSelector(getCopyProviderEN);
  const copyProvider =
    currentLanguage === 'en' ? copyProviderEN : copyProviderCY;
  const { s } = useParams();
  useTitle(
    'installer.UnderAllocationOfSockets.s9',
    'Are you sure you want to continue? - OZEV Electric Vehicle Chargepoint Grant - GOV.UK'
  );
  const applicationDocumentId = useSelector(getApplicationDocumentId);
  const [socketApplied, setSocketApplied] = useState('');
  const [socketInstalled, setSocketInstalled] = useState('');

  useEffect(() => {
    getChargePointDetails({ applicationDocumentId }).then((response) => {
      const { data } = response;
      setSocketApplied(data.number_of_chargepoint_sockets_applied);
      setSocketInstalled(data.number_of_chargepoint_sockets_installed);
    });
  }, []);
  const handleContinueButton = () => {
    history.push('/installer/installation-cost');
  };
  const pageModel = (
    <div>
      <h1 className="govuk-heading-l">
        {copyProvider.getCopy(
          'installer.UnderAllocationOfSockets.s1',
          'Are you sure you want to continue?'
        )}
      </h1>
      <p className="govuk-body">
        {copyProvider.getCopy(
          'installer.UnderAllocationOfSockets.s2',
          'You are claiming for less chargepoints sockets than you are allowed to.'
        )}
      </p>
      <p className="govuk-body">
        {copyProvider.getCopy(
          'installer.UnderAllocationOfSockets.s3',
          'Your customer has applied for a total of '
        )}
        {socketApplied}
        {copyProvider.getCopy(
          'installer.UnderAllocationOfSockets.s4',
          ' chargepoints sockets. That is the total amount you can claim for.'
        )}
      </p>
      <p className="govuk-body">
        {copyProvider.getCopy(
          'installer.UnderAllocationOfSockets.s5',
          'If you have installed '
        )}
        {socketInstalled}
        {copyProvider.getCopy(
          'installer.UnderAllocationOfSockets.s6',
          ' chargepoints sockets, you can continue but you will not be able to claim for the remaining sockets. '
        )}
      </p>
      <div className="govuk-button-group govuk-!-margin-top-9">
        <Button className="govuk-button" onClick={handleContinueButton}>
          {copyProvider.getCopy(
            'installer.UnderAllocationOfSockets.s7',
            'Accept and continue '
          )}
        </Button>
        {s === undefined || s === '' ? (
          <Link className="govuk-link" to="/installer/chargepoints-summary">
            {copyProvider.getCopy(
              'installer.UnderAllocationOfSockets.s8',
              'Return and review-2'
            )}
          </Link>
        ) : (
          <Link
            className="govuk-link"
            to={{}}
            onClick={() =>
              window.location.assign(
                '/car-parks/installer-2/chargepoint-model/'
              )
            }
          >
            {copyProvider.getCopy(
              'installer.UnderAllocationOfSockets.s8',
              'Return and review'
            )}
          </Link>
        )}
      </div>
    </div>
  );
  return pageModel;
};

export default UnderAllocationOfSockets;
